import { Observable, BehaviorSubject, of as observableOf } from 'rxjs';
import { mergeMap, catchError, share } from "rxjs/operators";
import { addProvider, IProviderDescriptor } from "../ServiceUtil";
import { SalesRepDelegate } from "./salesrep.delegate";
import
{
    INewSalesRep, ISalesRep,
    ISalesRepResponse,
    ISalesRepDetailResponse,
    ISalesRepBenchSubmission,
    ISalesRepBenchSubmissionStats,
    ISalesStatResponse,
    ISalesRepBenchSubmissionStatsDetail,
    ISalesRepBenchInterviewStats,
    ISalesRepBenchInterviewStatsDetail
} from "./salesrep.interface";
import { AuthenticationService } from "../AuthenticationService";

export class SalesRepService
{

    public salesRepData: ISalesRep[] = null;
    private salesRepSubject: BehaviorSubject<ISalesRep[]> = new BehaviorSubject(null);
    public salesReps: Observable<ISalesRep[]> = this.salesRepSubject;
    private selectedSalesRepId: string = "0";
    private selectedLeadActiveLeads: boolean = true;
    private _activeSalesReps: boolean = true;

    public salesRepInfo: ISalesRep = null;
    private salesRepInfoSubject: BehaviorSubject<ISalesRep> = new BehaviorSubject(null);
    public salesRep: Observable<ISalesRep> = this.salesRepInfoSubject;

    public salesRepDailySubmissionData: ISalesRepBenchSubmission[] = null;
    private salesRepDailySubmissionSubject: BehaviorSubject<ISalesRepBenchSubmission[]> = new BehaviorSubject(null);
    public salesRepsDailySubmission: Observable<ISalesRepBenchSubmission[]> = this.salesRepDailySubmissionSubject;


    public leadRepData: ISalesRep[] = null;
    private leadRepSubject: BehaviorSubject<ISalesRep[]> = new BehaviorSubject(null);
    public leadReps: Observable<ISalesRep[]> = this.leadRepSubject;
    private selectedLeadRepId: string = "0";


    public leadRepInfo: ISalesRep = null;
    private leadRepInfoSubject: BehaviorSubject<ISalesRep> = new BehaviorSubject(null);
    public leadRep: Observable<ISalesRep> = this.leadRepInfoSubject;

    public salesStatsData: ISalesRepBenchSubmissionStats[] = null;
    private salesStatsSubject: BehaviorSubject<ISalesRepBenchSubmissionStats[]> = new BehaviorSubject(null);
    public salesStats: Observable<ISalesRepBenchSubmissionStats[]> = this.salesStatsSubject;

    public salesStatsDetailData: ISalesRepBenchSubmissionStatsDetail[] = null;
    private salesStatsDetailSubject: BehaviorSubject<ISalesRepBenchSubmissionStatsDetail[]> = new BehaviorSubject(null);
    public salesStatsDetail: Observable<ISalesRepBenchSubmissionStatsDetail[]> = this.salesStatsDetailSubject;

    public interviewStatsData: ISalesRepBenchInterviewStats[] = null;
    private interviewStatsSubject: BehaviorSubject<ISalesRepBenchInterviewStats[]> = new BehaviorSubject(null);
    public interviewStats: Observable<ISalesRepBenchInterviewStats[]> = this.interviewStatsSubject;

    public interviewStatsDetailData: ISalesRepBenchInterviewStatsDetail[] = null;
    private interviewStatsDetailSubject: BehaviorSubject<ISalesRepBenchInterviewStatsDetail[]> = new BehaviorSubject(null);
    public interviewStatsDetail: Observable<ISalesRepBenchInterviewStatsDetail[]> = this.interviewStatsDetailSubject;

    selectedActiveSalesReps: ISalesRep[] = [];
    constructor(private salesRepDelegate: SalesRepDelegate, private authenticationService: AuthenticationService)
    {
    }

    private _fromDate: Date | string = null;
    get fromDate(): Date | string
    {
        return this._fromDate;
    }
    set fromDate(value: Date | string)
    {
        this._fromDate = value;
    }

    private _toDate: Date | string = null;
    get toDate(): Date | string
    {
        return this._toDate;
    }
    set toDate(value: Date | string)
    {
        this._toDate = value;
    }

    public get activeLeads(): boolean
    {
        return this.selectedLeadActiveLeads;
    }

    public setselectedActiveLeads(activeData: boolean): void
    {
        this.selectedLeadActiveLeads = activeData;
    }
    public get activeSalesReps(): boolean { return this._activeSalesReps; }
    public setActiveSalesReps(val: boolean):void{ this._activeSalesReps = val; }

    public get salesRepId(): string
    {
        return this.selectedSalesRepId;
    }

    public setselectedSalesRepId(salesRepId: string): void
    {
        this.selectedSalesRepId = salesRepId;
    }

    public get leadRepId(): string
    {
        return this.selectedLeadRepId;
    }

    public setselectedLeadRepId(salesRepId: string): void
    {
        this.selectedLeadRepId = salesRepId;
    }

    public getSelectedSalesRep(): ISalesRep
    {
        return this.salesRepData.find(salesRep => salesRep.salesRepId === this.salesRepId);
    }

    public getSalesRepById(salesRepId: string = ''): Observable<boolean>
    {
        if (salesRepId === "0")
        {
            this.salesRepInfo = null;
            this.salesRepInfoSubject.next(this.salesRepInfo);
            return observableOf(false);
        }
        const response = this.salesRepDelegate.getSalesRepBySalesRepId(salesRepId ? salesRepId : this.authenticationService.GetSalesRepId());
        return this.processSalesRep(response);
    }

    public getSalesRepData(): ISalesRep
    {
        return this.salesRepInfo;
    }

    public getAllSalesReps(hardReload:boolean = false)
    {
        if (this.salesRepData !== null && this.salesRepData.length > 0 && hardReload === false)
        {
            return observableOf(true);
        }
        const orgId = this.authenticationService.GetOrgId();

        const response = this.salesRepDelegate.getAllSalesRepsByOrgId(orgId, this._activeSalesReps);
        return this.processSalesReps(response);
    }

    public getSubmissionReport(fromDate: Date | string, toDate: Date | string, sendEmail: boolean)
    {

        const orgId = this.authenticationService.GetOrgId();
        const userId = this.authenticationService.GetUserId();

        const response = this.salesRepDelegate.getProcessSubmissionReport(orgId, userId, fromDate, toDate, sendEmail);
        return this.processSubmissionReport(response);
    }

    public getInterviewReport(fromDate: Date | string, toDate: Date | string, sendEmail: boolean)
    {

        const orgId = this.authenticationService.GetOrgId();
        const userId = this.authenticationService.GetUserId();

        const response = this.salesRepDelegate.getProcessInterviewReport(orgId, userId, fromDate, toDate, sendEmail);
        return this.processInterviewReport(response);
    }

    public getAllLeadReps(hardReload: boolean = false)
    {
        if (this.leadRepData !== null && this.leadRepData.length > 0 && hardReload == false)
        {
            return observableOf(true);
        }
        const orgId = this.authenticationService.GetOrgId();

        const response = this.salesRepDelegate.getAllLeadRepsByOrgId(orgId, this.selectedLeadActiveLeads);
        return this.processLeadReps(response);
    }

    public getLeadRepById(salesRepId: string = ''): Observable<boolean>
    {
        if (salesRepId === "0")
        {
            this.leadRepInfo = null;
            this.leadRepInfoSubject.next(this.leadRepInfo);
            return observableOf(false);
        }
        const response = this.salesRepDelegate.getSalesRepBySalesRepId(salesRepId ? salesRepId : this.authenticationService.GetSalesRepId());
        return this.processLeadRep(response);
    }

    public createNewSalesRep(salesRep: INewSalesRep): Observable<boolean>
    {
        const response = this.salesRepDelegate.createNewSalesRep({
            ...salesRep,
            ...this.authenticationService.getBaseRequest
        });
        return this.processSalesReps(response);
    }

    public UpdateSalesRep(salesRep: ISalesRep): Observable<boolean>
    {
        const orgId = this.authenticationService.GetOrgId();
        const userId = this.authenticationService.GetUserId();
        salesRep.orgId = orgId;
        salesRep.userId = userId;
        salesRep.clientTimeStamp = new Date().toISOString();
        salesRep.activeData = this.selectedActiveSalesReps.length > 0; 
        const response = this.salesRepDelegate.updateSalesRep(salesRep);
        return this.processSalesReps(response);
    }

    public createNewLeadRep(salesRep: INewSalesRep): Observable<boolean>
    {
        const response = this.salesRepDelegate.createNewLeadRep({
            ...salesRep,
            ...this.authenticationService.getBaseRequest
        });
        return this.processLeadReps(response);
    }

    public UpdateLeadRep(salesRep: ISalesRep): Observable<boolean>
    {
        salesRep.activeData = this.selectedLeadActiveLeads;
        const response = this.salesRepDelegate.updateLeadRep({
            ...salesRep,
            ...this.authenticationService.getBaseRequest
        });
        return this.processLeadReps(response);
    }

    public getSalesRepDailySubmission(fromDate: Date | string, toDate: Date | string, benchStatus: string)
    {

        const orgId = this.authenticationService.GetOrgId();
        this.fromDate = fromDate;
        this.toDate = toDate;
        const response = this.salesRepDelegate.getSalesRepDailySubmissionsBySalesRepId(this.authenticationService.GetSalesRepId(), fromDate, toDate, benchStatus);
        return this.processSalesRepDailySubmission(response);
    }

    private processSalesRepDailySubmission(salesReps: Observable<ISalesRepResponse>): Observable<boolean>
    {
        salesReps.subscribe(onAccountManagersSuccess.bind(this), onAccountManagersFault.bind(this));

        return salesReps.pipe(mergeMap((response: ISalesRepResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onAccountManagersSuccess(salesRepResponse: ISalesRepResponse)
        {
            if (salesRepResponse.success)
            {
                this.selectedSalesRepId = salesRepResponse.salesRepId ? salesRepResponse.salesRepId : this.selectedSalesRepId;
                this.salesRepDailySubmissionData = salesRepResponse.salesRepSubmission;
                this.salesRepDailySubmissionSubject.next(this.salesRepDailySubmissionData);
            }
        }

        function onAccountManagersFault(error: any)
        {
            // SalesRepService.logger.error(`processSalesReps Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processSalesReps(salesReps: Observable<ISalesRepResponse>): Observable<boolean>
    {
        salesReps.subscribe(onAccountManagersSuccess.bind(this), onAccountManagersFault.bind(this));

        return salesReps.pipe(mergeMap((response: ISalesRepResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onAccountManagersSuccess(salesRepResponse: ISalesRepResponse)
        {
            if (salesRepResponse.success)
            {
                this.selectedSalesRepId = salesRepResponse.salesRepId ? salesRepResponse.salesRepId : this.selectedSalesRepId;
                this.salesRepData = salesRepResponse.salesReps;
                this.salesRepSubject.next(this.salesRepData);

                if (salesRepResponse.salesRepId)
                {
                    this.salesRepInfo = salesRepResponse.salesReps.find(x => x.salesRepId === salesRepResponse.salesRepId);
                    this.salesRepInfoSubject.next(this.salesRepInfo);
                }
            }
        }

        function onAccountManagersFault(error: any)
        {
            // SalesRepService.logger.error(`processSalesReps Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processSalesRep(salesRep: Observable<ISalesRepDetailResponse>): Observable<boolean>
    {
        salesRep.subscribe(onSuccess.bind(this), onFault.bind(this));

        return salesRep.pipe(mergeMap((response: ISalesRepDetailResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(salesRepResponse: ISalesRepDetailResponse)
        {
            if (salesRepResponse.success)
            {
                this.salesRepInfo = salesRepResponse.salesRep;
                this.selectedSalesRepId = salesRepResponse.salesRep.salesRepId;
                this.salesRepInfoSubject.next(this.salesRepInfo);
            }
        }

        function onFault(error: any)
        {
            //SalesRepService.logger.error(`processSalesReps Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processLeadReps(salesReps: Observable<ISalesRepResponse>): Observable<boolean>
    {
        salesReps.subscribe(onAccountManagersSuccess.bind(this), onAccountManagersFault.bind(this));

        return salesReps.pipe(mergeMap((response: ISalesRepResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onAccountManagersSuccess(salesRepResponse: ISalesRepResponse)
        {
            if (salesRepResponse.success)
            {
                this.selectedLeadRepId = salesRepResponse.salesRepId ? salesRepResponse.salesRepId : this.selectedLeadRepId;
                this.leadRepData = salesRepResponse.salesReps;
                this.leadRepSubject.next(this.leadRepData);
                if (salesRepResponse.salesRepId)
                {
                    this.leadRepInfo = salesRepResponse.salesReps.find(x => x.salesRepId === salesRepResponse.salesRepId);
                    this.leadRepInfoSubject.next(this.leadRepInfo);
                }
            }
        }

        function onAccountManagersFault(error: any)
        {
            // SalesRepService.logger.error(`processSalesReps Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processLeadRep(salesRep: Observable<ISalesRepDetailResponse>): Observable<boolean>
    {
        salesRep.subscribe(onSuccess.bind(this), onFault.bind(this));

        return salesRep.pipe(mergeMap((response: ISalesRepDetailResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(salesRepResponse: ISalesRepDetailResponse)
        {
            if (salesRepResponse.success)
            {
                this.leadRepInfo = salesRepResponse.salesRep;
                this.selectedLeadRepId = salesRepResponse.salesRep.salesRepId;
                this.leadRepInfoSubject.next(this.leadRepInfo);
            }
        }

        function onFault(error: any)
        {
            //SalesRepService.logger.error(`processSalesReps Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processSubmissionReport(salesReps: Observable<ISalesStatResponse>): Observable<boolean>
    {
        salesReps.subscribe(onAccountManagersSuccess.bind(this), onAccountManagersFault.bind(this));

        return salesReps.pipe(mergeMap((response: ISalesStatResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onAccountManagersSuccess(salesRepResponse: ISalesStatResponse)
        {
            if (salesRepResponse.success)
            {

                this.salesStatsData = salesRepResponse.salesRepBenchSubmissionStats;
                this.salesStatsSubject.next(this.salesStatsData);

                this.salesStatsDetailData = salesRepResponse.salesReps;
                this.salesStatsDetailSubject.next(this.salesStatsDetailData);

            }
        }

        function onAccountManagersFault(error: any)
        {
            // SalesRepService.logger.error(`processSalesReps Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processInterviewReport(salesReps: Observable<ISalesStatResponse>): Observable<boolean>
    {
        salesReps.subscribe(onAccountManagersSuccess.bind(this), onAccountManagersFault.bind(this));

        return salesReps.pipe(mergeMap((response: ISalesStatResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onAccountManagersSuccess(salesRepResponse: ISalesStatResponse)
        {
            if (salesRepResponse.success)
            {


                this.interviewStatsData = salesRepResponse.salesRepBenchInterviewStats;
                this.interviewStatsSubject.next(this.interviewStatsData);

                this.interviewStatsDetailData = salesRepResponse.benchInterviews;
                this.interviewStatsDetailSubject.next(this.interviewStatsDetailData);

            }
        }

        function onAccountManagersFault(error: any)
        {
            // SalesRepService.logger.error(`processSalesReps Fault - Error (${JSON.stringify(error)})`);
        }
    }

}